module.exports = __webpack_public_path__ + "img/shapelog-logo.b08b3b27.svg";